import React from 'react';
import { Box } from '@common-fe/common-fe';

import Sidebar from '../Sidebar';
interface Props {
  children: React.ReactNode;
}
const MobileMenu: React.FC<Props> = ({ children }) => {
  return (
    <Box background="navigationBackground" pad={{ top: 'xl', bottom: 'm'}}>
      <Sidebar isMobileMode>
      
        {children}
      </Sidebar>
    </Box>
  );
};

export default MobileMenu;
